import { z } from 'my-zod'
import { taxPolicyModel } from './tax-policy-model'

export const taxPolicySystemView = taxPolicyModel.augment({
  isDeleted: z.boolean()
})

export type taxPolicySystemView = z.infer<typeof taxPolicySystemView>
